export default function($) {
  var speed = 90,
      touchmoved;
  var mobileBreakpoint = window.matchMedia('(min-width: 1280px)');
  var originalWindowWidth = $(window).width();

  // Fonction helper pour vérifier le breakpoint
  function isMobileView() {
    return !mobileBreakpoint.matches;
  }

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-active')) {
      $('.js-nav-items').slideUp(speed);
      $('.js-nav-items .js-nav-close').remove();
      $('.js-nav-items').removeClass('nav-items-active');
      $(this).removeClass('nav-trigger-active');
    } else {
      $('.js-nav-items').css('display', 'flex');
      $('.js-nav-items').prepend('<li class="js-nav-close nav-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z"/></svg></li>');
      $('.js-nav-items').addClass('nav-items-active');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.js-nav-items').on('click touch', '.js-nav-close svg', function() {
    $('.js-nav-items').slideUp(speed);
    $('.js-nav-items .js-nav-close').remove();
    $('.js-nav-items').removeClass('nav-items-active');
    $('.js-nav-mobile-button').removeClass('nav-trigger-active');
  })

  $('.js-nav').find("li.menu-item-has-children").on("click touchend", function (event) {
    if( isMobileView() ) {
      //if the one touched is already opened, we want to follow its link
      if(touchmoved != true){
        if($(this).hasClass('menu-item-has-children--active')) {
          window.location = $(this).find('>a').attr("href");
        }
        //then we want to open submenu without following the link
        else {
          event.preventDefault();
          event.stopPropagation();
          $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
            $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
          });
          $(this).children('.sub-menu').slideDown(speed);
          $(this).addClass('menu-item-has-children--active');
        }
      }
    }
  });

  $('.footer-nav').find("li.menu-item-has-children").on("click touchend", function (event) {
    if( $(window).width() < 1024 ) {
      //if the one touched is already opened, we want to follow its link
      if(touchmoved != true){
        if($(this).hasClass('menu-item-has-children--active')) {
          window.location = $(this).find('>a').attr("href");
        }
        //then we want to open submenu without following the link
        else {
          event.preventDefault();
          event.stopPropagation();
          $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
            $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
          });
          $(this).children('.sub-menu').slideDown(speed);
          $(this).addClass('menu-item-has-children--active');
        }
      }
    }
  });

  $('.nav .menu-item-has-children').click(function () {

    if( !isMobileView() ) {
      $(this).siblings('.current_page_item, .current-menu-ancestor').children('a').addClass('temporary-inactive');
      $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
        $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
        $(sibling).children('.sub-menu-intro-wrapper').removeClass('show-sub-menu-intro');
      });
      $(this).children('.sub-menu').slideToggle(speed);
      $(this).children('.sub-menu-intro-wrapper').toggleClass('show-sub-menu-intro');
      $(this).toggleClass('menu-item-has-children--active');
    }

    // Calc sub-menu-intro height for show menu item under
    $('.menu-item-has-children.menu-item-has-children--active').each(function() {
      var subMenuIntroHeight = $(this).find('.sub-menu-intro-wrapper').outerHeight();
      $(this).find('.sub-menu').css('top', subMenuIntroHeight + 'px');
    })
  });

  $(window).resize(function() {
    $('.menu-item-has-children.menu-item-has-children--active').each(function() {
      var subMenuIntroHeight = $(this).find('.sub-menu-intro-wrapper').outerHeight();
      $(this).find('.sub-menu').css('top', subMenuIntroHeight + 'px');
    })
  });


  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.nav .sub-menu').is(":visible")) {
        $('.nav .sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
        $('.sub-menu-intro-wrapper').removeClass('show-sub-menu-intro');
        $('.nav .js-nav-items ul .current_page_item a, .nav .js-nav-items ul .current-menu-ancestor a').removeClass('temporary-inactive');
      }
      if($('.js-nav-items').hasClass('nav-items-active')) {
        $('.js-nav-items').slideUp(speed);
        $('.js-nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
        $('.nav .js-nav-items ul .current_page_item a, .nav .js-nav-items ul .current-menu-ancestor a').removeClass('temporary-inactive');
      }
    }

  });

  $(window).resize(function() {
    if( !isMobileView() ) {
      $('.js-nav-items').css('display', 'flex');
    } else {
      if( $(window).width() != originalWindowWidth) {
        $('.js-nav-items').css('display', 'none');
        $('.js-nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  })

  $(document).ready(function() {
    function updateGrid() {
      $('.sub-menu .sub-menu').each(function() {
          var subMenu = $(this);
          var menuItems = subMenu.find('.menu-item');
          var parentMenuItem = subMenu.parent('.menu-item');
        if( $(window).width() >= 1536 ) {
          if (menuItems.length > 11) {
            parentMenuItem.css('grid-column', 'span 2 / span 2');
            subMenu.addClass('grid-cols-2 gap-4');
            subMenu.removeClass('grid-cols-3 gap-4');
          }
        } else if( $(window).width() >= 1280 && $(window).width() < 1536 ) {
          if (menuItems.length > 16) {
            parentMenuItem.css('grid-column', 'span 3 / span 3');
            subMenu.addClass('grid-cols-3 gap-4');
          } else if (menuItems.length > 8) {
              parentMenuItem.css('grid-column', 'span 2 / span 2');
              subMenu.addClass('grid-cols-2 gap-4');
          }
        }
      });
    }

    updateGrid();

    $(window).on('resize', function() {
      updateGrid();
    });
  });

  function adjustColors() {
    if( isMobileView() ) {
      $('.nav .menu-item').removeClass('bg-oxford-lime bg-primary-300 bg-oxford-red bg-oxford-lilac');
    } else {
      $('.nav .first-level-sub-menu').each(function() {
        var colors = ['bg-oxford-lilac', 'bg-oxford-lime', 'bg-primary-300', 'bg-oxford-red', ];
        var colorIndex = 0;
        $(this).find('.menu-item').not('.second-level-menu-item.menu-item-has-children').not('.second-level-sub-menu .menu-item').each(function() {
          $(this).addClass(colors[colorIndex]);
          colorIndex++;
          if (colorIndex >= colors.length) {
            colorIndex = 0;
          }
        })
      })
    }
  };

  adjustColors();

  $(window).resize(function() {
      adjustColors();
  });

  $('.js-languages-button').on( 'click', function() {
    $(this).siblings('.js-languages-select').slideToggle(speed);
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });


  const featuredImage = $('.js-feature-image-page');

  const header = $('.header');
  const navigations = $('#navigations');

  if (featuredImage.length > 0) {
      navigations.removeClass('sticky').addClass('fixed top-0 left-0 right-0');
      header.find('.js-logo').addClass('hidden');
      header.find('.js-logo-blue-bg').removeClass('hidden');

  }

  var $headerContainer = $('.header-bg-primary-300, .header-bg-oxford-green, .header-bg-oxford-lilac');
  var $header = $headerContainer.find('#navigations');
  var scrollThreshold = 200;

  if ($headerContainer.hasClass('header-bg-primary-300')) {
    $header.addClass('bg-primary-300');
  } else if ($headerContainer.hasClass('header-bg-oxford-green')) {
    $header.addClass('bg-oxford-green');
  } else if ($headerContainer.hasClass('header-bg-oxford-lilac')) {
    $header.addClass('bg-oxford-lilac');
  }

  $(window).scroll(function() {
    if ($(window).scrollTop() < scrollThreshold) {
      if ($headerContainer.hasClass('header-bg-primary-300')) {
        $header.addClass('bg-primary-300');
      } else if ($headerContainer.hasClass('header-bg-oxford-green')) {
          $header.addClass('bg-oxford-green');
      } else if ($headerContainer.hasClass('header-bg-oxford-lilac')) {
        $header.addClass('bg-oxford-lilac');
      }
    } else {
      if ($headerContainer.hasClass('header-bg-primary-300')) {
        $header.removeClass('bg-primary-300');
      } else if ($headerContainer.hasClass('header-bg-oxford-green')) {
          $header.removeClass('bg-oxford-green');
      } else if ($headerContainer.hasClass('header-bg-oxford-lilac')) {
        $header.removeClass('bg-oxford-lilac');
      }
    }
  });

  var $navigations = $('#navigations');
  var navigationsHeight = $navigations.outerHeight();
  var lastScrollTop = 0;

  $(window).resize(function() {
    navigationsHeight = $navigations.outerHeight();
  });

  $(window).scroll(function() {
    var st = window.scrollY || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      if (!$('body').hasClass('page-template-template-scribzee')) {
        $navigations.addClass('absolute');
        $navigations.removeClass('fixed');
        if (st > navigationsHeight) {
          $navigations.css('top', '-' + navigationsHeight + 'px');
        }
      } else {
        $('.scribzee-header-wrapper').css('top', '-' + navigationsHeight + 'px');
        $navigations.css('top', '-' + navigationsHeight + 'px');
      }
    } else {
      $('.scribzee-header-wrapper').css('top', '0');
      $navigations.css('top', '0');
      if (!$('body').hasClass('page-template-template-scribzee')) {
        $navigations.addClass('fixed');
        $navigations.removeClass('absolute');
      }
    }
    lastScrollTop = st <= 0 ? 0 : st;
  })
}
